module.exports = __webpack_public_path__ + "img/orbit-homepage-background-mobile-l.5148ee42.png";